<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    cargando: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      numeroVuelo: this.item.numeroVuelo,
      codigoCompaniaAerea: this.item.codigoCompaniaAerea,
    };
  },
  methods: {
    formatDate(fecha) {
      const partes = fecha.slice(0, 10).split("-");
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },
  },
};
</script>

<template>
  <tr class="trasladosIncluidos_item">
    <td>{{ item.codigoTipoTraslado }}</td>
    <td>{{ formatDate(item.fechaInicioServicio) }}</td>
    <td>{{ item.nombreCiudadTraslado }}</td>
    <td>
      <input v-model="codigoCompaniaAerea" :disabled="cargando" />
    </td>
    <td>
      <input v-model="numeroVuelo" :disabled="cargando" />
    </td>
    <td>
      <button
        @click="
          $emit('update', {
            serviceId: item.idServicioCarga,
            codigoCompaniaAerea,
            numeroVuelo,
          })
        "
        type="button"
        :disabled="cargando"
      >
        <template v-if="cargando">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </template>
        <template v-else>
          OK
        </template>
      </button>
    </td>
  </tr>
</template>

<style>
.paso3 #reservar .table-condensed > tbody > tr.trasladosIncluidos_item > td,
.paso3 #reservar .table-condensed > tbody > tr.trasladosIncluidos_item > th {
  padding: 2px !important;
}
.trasladosIncluidos_item input {
  width: 40px;
}
.trasladosIncluidos_item button {
  background: var(--gris-oscuro);
  color: #ffffff;
  border: 0;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  font-weight: 700;
  border-radius: 5px;
  min-height: 20px;
  text-transform: capitalize;
  text-align: center;
}
.trasladosIncluidos_item button:disabled {
  color: var(--gris-oscuro);
  background: var(--gris-claro);
}
</style>
